export default __webpack_public_path__ + "static/media/email_verification_success.81cd1ff8.png";